// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AiccExitController from "./aicc_exit_controller"
application.register("aicc-exit", AiccExitController)

import AnnouncementController from "./announcement_controller"
application.register("announcement", AnnouncementController)

import AudioPlayerController from "./audio_player_controller"
application.register("audio-player", AudioPlayerController)

import AutoFilterController from "./auto_filter_controller"
application.register("auto-filter", AutoFilterController)

import BulkUpdateController from "./bulk_update_controller"
application.register("bulk-update", BulkUpdateController)

import CertificateMappingController from "./certificate_mapping_controller"
application.register("certificate-mapping", CertificateMappingController)

import ConfettiController from "./confetti_controller"
application.register("confetti", ConfettiController)

import DisableOnSubmitController from "./disable_on_submit_controller"
application.register("disable-on-submit", DisableOnSubmitController)

import FlatpickrController from "./flatpickr_controller"
application.register("flatpickr", FlatpickrController)

import FormRedirectController from "./form_redirect_controller"
application.register("form-redirect", FormRedirectController)

import HighlightController from "./highlight_controller"
application.register("highlight", HighlightController)

import ImageModalController from "./image_modal_controller"
application.register("image-modal", ImageModalController)

import JobStatusController from "./job_status_controller"
application.register("job-status", JobStatusController)

import LiveSearchController from "./live_search_controller"
application.register("live-search", LiveSearchController)

import LmsSessionController from "./lms_session_controller"
application.register("lms-session", LmsSessionController)

import MarketplaceMapController from "./marketplace_map_controller"
application.register("marketplace-map", MarketplaceMapController)

import RemoteCompanySelectController from "./remote_company_select_controller"
application.register("remote-company-select", RemoteCompanySelectController)

import RemoteFacilitySelectController from "./remote_facility_select_controller"
application.register("remote-facility-select", RemoteFacilitySelectController)

import RemotePageSelectController from "./remote_page_select_controller"
application.register("remote-page-select", RemotePageSelectController)

import RemoteQuestionSelectController from "./remote_question_select_controller"
application.register("remote-question-select", RemoteQuestionSelectController)

import RemoteUserSelectController from "./remote_user_select_controller"
application.register("remote-user-select", RemoteUserSelectController)

import RemovalsController from "./removals_controller"
application.register("removals", RemovalsController)

import ScormController from "./scorm_controller"
application.register("scorm", ScormController)

import ScormNotifierController from "./scorm_notifier_controller"
application.register("scorm-notifier", ScormNotifierController)

import SlideDelayController from "./slide_delay_controller"
application.register("slide-delay", SlideDelayController)

import SortableController from "./sortable_controller"
application.register("sortable", SortableController)

import StarRatingController from "./star_rating_controller"
application.register("star-rating", StarRatingController)

import StripeCardsController from "./stripe_cards_controller"
application.register("stripe-cards", StripeCardsController)

import StripeElementsController from "./stripe_elements_controller"
application.register("stripe-elements", StripeElementsController)

import TomSelectController from "./tom_select_controller"
application.register("tom-select", TomSelectController)

import CharacterCountController from "./character_count_controller"
application.register("character-count", CharacterCountController)
